import styled from 'styled-components';

export const NavbarLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;

  img {
    height: 42px;        /* tamaño ideal */
    width: auto;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    img {
      height: 34px;
    }
  }
`;